// !!! IF YOU CHANGE ANY OF THE EXISTING PROPERTIES HERE, !!!
// !!! STUFF WILL BREAK                                   !!!
var StaticElements;(function(a){a.Footer="footer-section",a.Header="header-section",a.Cookie="cookie-section"})(StaticElements||(StaticElements={}));export{StaticElements};